import contract_bronze from 'img/icons/contract-bronze.svg'
import contract_bronze_2 from 'img/icons/contract-bronze-2.svg'
import hand_gray from 'img/icons/hand-gray.svg'
import standards_bronze from 'img/icons/standards-bronze.svg'
// import contract_bronze from 'img/icons/contract-bronze.svg'
// import contract_bronze_2 from 'img/icons/contract-bronze-2.svg'
export interface ITerm {
	title: string
	items: ITermItem[]
}
export interface ITermItem {
	country: string
	title: string
	icon: string
	id: string
}

export const termItemsCard: ITerm = {
	title: 'TermsOfContract',
	items: [
		{
			id: '1',
			country: 'de',
			title: 'CreditCardTermsCondition',
			icon: contract_bronze,
		},
		{
			id: '2',
			country: 'de',
			title: 'ConditionOverview',
			icon: contract_bronze_2,
		},
		{
			id: '3',
			country: 'de',
			title: 'InsuraceCondition',
			icon: hand_gray,
		},
		{
			id: '4',
			country: 'de',
			title: 'EuropeanStandard',
			icon: standards_bronze,
		},
		{
			id: '5',
			country: 'no',
			title: 'CreditCardTermsCondition',
			icon: contract_bronze,
		},
		{
			id: '6',
			country: 'no',
			title: 'IDAndTheftInsurance',
			icon: contract_bronze_2,
		},
		{
			id: '7',
			country: 'no',
			title: 'TravelInsurance',
			icon: standards_bronze,
		},
		{
			id: '8',
			country: 'no',
			title: 'InsuraceCondition',
			icon: hand_gray,
		},
		{
			id: '9',
			country: 'at',
			title: 'CreditCardTermsCondition',
			icon: contract_bronze,
		},
		{
			id: '10',
			country: 'at',
			title: 'ConditionOverview',
			icon: contract_bronze,
		},
		{
			id: '11',
			country: 'at',
			title: 'InsuraceCondition',
			icon: hand_gray,
		},
		{
			id: '12',
			country: 'at',
			title: 'EuropeanStandard',
			icon: contract_bronze,
		},
		{
			id: '20',
			country: 'at',
			title: 'BankingSecrecyRelease',
			icon: contract_bronze,
		},
		{
			id: '24',
			country: 'it',
			title: 'CreditCardTermsCondition',
			icon: contract_bronze,
		},
		{
			id: '55',
			country: 'es',
			title: 'CreditCardTermsCondition',
			icon: contract_bronze,
		},
	],
}

export const termItemsDeposit: ITerm = {
	title: 'TermsOfContract',
	items: [
		{
			id: '14',
			country: 'de',
			title: 'CreditCardTermsCondition',
			icon: contract_bronze,
		},
		{
			id: '15',
			country: 'de',
			title: 'SwedishDepositGuarantee',
			icon: standards_bronze,
		},
		{
			id: '16',
			country: 'de',
			title: 'ProductInformationSheet',
			icon: contract_bronze_2,
		},
		{
			id: '17',
			country: 'no',
			title: 'CreditCardTermsCondition',
			icon: contract_bronze,
		},
		{
			id: '18',
			country: 'no',
			title: 'SwedishDepositGuarantee',
			icon: standards_bronze,
		},
		{
			id: '19',
			country: 'no',
			title: 'NorwegianDepositGuarantee',
			icon: standards_bronze,
		},
	],
}

export const termItemsDepositFixed: ITerm = {
	title: 'TermsOfContract',
	items: [
		{
			id: '21',
			country: 'de',
			title: 'CreditCardTermsCondition',
			icon: contract_bronze,
		},
		{
			id: '22',
			country: 'de',
			title: 'SwedishDepositGuarantee',
			icon: standards_bronze,
		},
		{
			id: '23',
			country: 'de',
			title: 'ProductInformationSheet',
			icon: contract_bronze_2,
		},
	],
}
